import React, { Component } from "react"
// import { compare_list, missing_err, display_list_r, display_list_p, compare_table, display_table } from './SnapUtils'
import { missing_err, compare_table } from './SnapUtils'
// import { parent_info, parent_hstatus, parent_notemployed, parent_employment, parent_education } from '../../variables/Required'

import { ParentsEP } from '../../variables/Config'
import { snapshotOptions } from '../../variables/ComboValues'
import { Diploma_microLegend } from '../FamilyParent/ParentDiploma'
import { ParentEducation_microLegend } from '../FamilyParent/ParentEducation'
import { ParentInfo_microLegend } from '../FamilyParent/ParentGeneral'
import { Employment_microLegend } from '../FamilyParent/ParentEmployment'
import { EmployBoz_microLegend } from '../FamilyParent/ParentEmployBoz'
import { NotEmployed_microLegend } from '../FamilyParent/ParentNotEmployed'
// import { EmployHistory_microLegend } from '../FamilyParent/ParentEmployHistory'
import { HealthStatus_microLegend } from '../FamilyParent/ParentHealthStatus'
import { HealthIssues_microLegend } from '../FamilyParent/ParentHealth'
import YSpinner from  '../../elements/Spinner/Spinner'

// phase is resolved in parent call
//<ParentImprove type={'snapshot'} snapId={123} />
//<ParentImprove type={'compare'} fromId={123} toId={123} />
export default class ParentImprove extends Component {
    constructor(props){
        super(props)
        this._isMounted = false
        this.state = {
            isLoadingFrom: true,
            isLoadingTo: true,
            dfrom: {},
            dto: {}
        }

    }
          // fetch any snapshot (family or parent) by cpt id 
    fetchSnapshot(url, dir) {
            if (dir === 0) // Loading 'from' or 'to'
                this.setState({isLoadingFrom: true}) 
            else 
                this.setState({isLoadingTo: true}) 
    // http://yahav/wp-json/wp/v2/digma_families0/8676?fields=id,title,acf
            fetch(url)
            .then(response => {
                if (!this._isMounted) return null
                if (response.ok)
                    return response.json()
                throw new Error('fetchSnapshot: Something went wrong ...')
            })
            .then(cpt => {             
                if (!this._isMounted) 
                    return null
                if (dir === 0) // Loading 'from' or 'to'
                    this.setState({dfrom:cpt, isLoadingFrom: false}) 
                else
                    this.setState({dto:cpt, isLoadingTo: false}) 
                return (cpt) // can be void - no one is looking...
            })/*.then( (cpt) => {
                console.log("fetch cpt",cpt)
                console.log("fetch dfrom",this.state.dfrom)
                console.log("fetch dto",this.state.dto)
                //console.log("FAMILYLOG",this.state.cpt['acf']['familylog_array'])
                //console.log("family_basic",this.state.cpt['acf']['family_basic'])
            })*/
            .catch(restError => {
                if (!this._isMounted) return null
                if (restError.name === 'AbortError') return; 
                this.setState({ restError: restError, isLoading: false })
            })
            return null
    }
    componentDidMount(){
        // is mounted
        this._isMounted = true
        const {snap, fromId, toId} = this.props
        
        let fromIndex = snapshotOptions.indexOf(snap['from'])
        this.fetchSnapshot(ParentsEP() +fromIndex+'/'+fromId+'?fields=id,title,acf', 0) // dir == 0 from

        if (this.props.snap['to'] === 'עכשיו')
            this.fetchSnapshot(ParentsEP() +'/'+toId+'?fields=id,title,acf', 1) // dir == 1 to
        else{
            let toIndex = snapshotOptions.indexOf(snap['to'])
            this.fetchSnapshot(ParentsEP() +toIndex+'/'+toId+'?fields=id,title,acf', 1) // dir == 1 to
        }
    }
    componentWillUnmount() {
        this._isMounted = false
    }
    compare_info = (list, list2, labels) => {
        //console.log("compare_list list", list)
        //console.log("compare_list list2", list2)
        if (list === undefined || list === false )
            return missing_err("חסרה הגדרה של כל נתוני הרשימה הראשונה")
        if (list2 === undefined || list2 === false )
            return missing_err("חסרה הגדרה של כל נתוני הרשימה השניה")
    
        let nullEl=0
        let resultList = Object.keys(list).map( item => {
            let label = labels[item] ? labels[item] : 'ללא שם שדה'
            if (list[item] !== list2[item] )
                return(<div key={item}  className="snap-item">
                            <span className="snap-label">{label}</span>
                            <span className="snap-item-data">{list[item]}</span>
                            <span className="snap-item-data2">{list2[item]}</span>
                        </div>)
            nullEl += 1
            return null 
        })
        if (resultList.length === nullEl)
            return <div>אין שינוי</div>
        return resultList
    }
    render(){
        const {snap} = this.props
        const {isLoadingTo, isLoadingFrom, dfrom, dto } = this.state
        if (snap['from'] === "" && snap['to'] === "") return null

        if (isLoadingTo || isLoadingFrom)
            return <YSpinner /> // <h2>טוען תמונות מצב...</h2>

        return (
            <div style={{clear:'both'}}>
                <div className="snap-display" style={{marginRight: '30px'}}>
                    <h4>נתוני הורה >> מידע כללי</h4>
                    {this.compare_info(dfrom['acf']['parent_info'], dto['acf']['parent_info'],  ParentInfo_microLegend)}
                    <h4>נתוני הורה >> מצב תעסוקה</h4>
                    {this.compare_info(dfrom['acf']['parent_employment'], dto['acf']['parent_employment'], Employment_microLegend)}
                    <h4>נתוני הורה >> עבודות במקביל</h4>
                    {compare_table(dfrom['acf']['parent_employ_boz'], dto['acf']['parent_employ_boz'], EmployBoz_microLegend)}
                   
                    <h4>נתוני הורה >> מצב אבטלה</h4>
                    {this.compare_info(dfrom['acf']['parent_notemployed'], dto['acf']['parent_notemployed'], NotEmployed_microLegend)}
                    <h4>נתוני הורה >> נתוני השכלה</h4>
                    {this.compare_info(dfrom['acf']['parent_education'], dto['acf']['parent_education'], ParentEducation_microLegend)}
                    <h4>נתוני הורה >> רשימת הכשרות</h4>
                    {compare_table(dfrom['acf']['parent_diploma'], dto['acf']['parent_diploma'],  Diploma_microLegend)}
                    <h4>נתוני הורה >> מצב בריאותי</h4>
                    {this.compare_info(dfrom['acf']['parent_hstatus'], dto['acf']['parent_hstatus'], HealthStatus_microLegend)}                     
                    <h4>נתוני הורה >> בעיות בריאות</h4>
                    {compare_table(dfrom['acf']['health_issues'], dto['acf']['health_issues'], HealthIssues_microLegend)}
                </div>                
            </div>
        )
    }
}
